import { render, staticRenderFns } from "./media-refers.vue?vue&type=template&id=a21e9c42&scoped=true&"
import script from "./media-refers.vue?vue&type=script&lang=js&"
export * from "./media-refers.vue?vue&type=script&lang=js&"
import style0 from "./media-refers.vue?vue&type=style&index=0&id=a21e9c42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21e9c42",
  null
  
)

export default component.exports